var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remix 1",
    clipPath: "url(#clip0_2532_30371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9793 5.717C10.9306 5.58667 10.8059 5.5 10.6666 5.5H6.64161L8.96328 0.986C9.03628 0.844 8.99861 0.670333 8.87294 0.571667C8.81228 0.523667 8.73928 0.5 8.66661 0.5C8.58894 0.5 8.51128 0.527333 8.44895 0.581L5.99995 2.696L1.11561 6.91433C1.01028 7.00533 0.972279 7.15233 1.02095 7.28267C1.06961 7.413 1.19395 7.5 1.33328 7.5H5.35828L3.03661 12.014C2.96361 12.156 3.00128 12.3297 3.12695 12.4283C3.18761 12.4763 3.26061 12.5 3.33328 12.5C3.41095 12.5 3.48861 12.4727 3.55095 12.419L5.99995 10.304L10.8843 6.08567C10.9899 5.99467 11.0276 5.84767 10.9793 5.717Z",
    fill: "#FFAC33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2532_30371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/Lightning.59420a31269b5c523e450791f52f654f.svg";
export { ForwardRef as ReactComponent };